import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vuelidate";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import axios from "axios";
import AuthPlugin from "@/api/AuthPlugin";
import Vuetify from "vuetify";
import DownloadExcel from "newt-vuejsdownloadexcel";
import { i18n } from "@/plugins/i18n";
import { Trans } from "./plugins/Translation";
import "@progress/kendo-theme-default/dist/all.css";
import customKendoGridComponent from "@/Components/KendoGrid/customkendoGridComponent.vue";
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);

Vue.component("downloadExcel", DownloadExcel);
Vue.component("fercam-kendogrid", customKendoGridComponent);

Vue.prototype.$apiRoot = process.env.VUE_APP_API_URL;
//Vue.prototype.$apiRoot = "https://localhost:44307/api/";
const base = axios.create({
  baseURL: Vue.prototype.$apiRoot
});

Vue.prototype.$http = base;

Vue.use(Vuetify, {
  theme: {
    primary: "#279947"
  }
});

Vue.use(AuthPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
